// Application access workflow details
export * from "./applicationAccessWorkflow.component";
export * from "./applicationAccessWorkflow.service";



// WEBPACK FOOTER //
// ./src/app/modules/workflow/applicationAccess/index.ts